import {
  Avatar,
  Button,
  Form,
  Input,
  Space,
  Tooltip,
  Typography,
} from 'antd';
import { CheckOutlined, CloseOutlined, EditOutlined } from '@ant-design/icons';
import React, { useState } from 'react';
import {
  bool, func, number, string,
} from 'prop-types';
import I18n from 'i18n-js';

const { Text, Paragraph } = Typography;
const { TextArea } = Input;

const CommentItem = ({
  id = null,
  authorName = '',
  avatarUrl = '',
  content = '',
  createdAt = '',
  canEdit = false,
  onUpdate = null,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [form] = Form.useForm();

  const handleSave = async () => {
    const values = await form.validateFields();
    setIsSaving(true);
    try {
      await onUpdate(id, values.content);
      setIsEditing(false);
    } finally {
      setIsSaving(false);
    }
  };

  const handleCancel = () => {
    setIsEditing(false);
    form.setFieldsValue({ content });
  };

  const handleStartEditing = () => {
    form.setFieldsValue({ content });
    setIsEditing(true);
  };

  return (
    <div className="ticket-comment">
      <Avatar src={avatarUrl} size={36} className="ticket-comment__avatar" />

      <div className="ticket-comment__body">
        <div className="ticket-comment__header">
          <Text strong className="ticket-comment__author">{authorName}</Text>
          <Text type="secondary" className="ticket-comment__date">{createdAt}</Text>
          {canEdit && !isEditing && (
            <Tooltip title={I18n.t('helpers.submit.ticket_comment.edit')}>
              <Button
                type="text"
                size="small"
                icon={<EditOutlined />}
                className="ticket-comment__edit-btn"
                aria-label={I18n.t('helpers.submit.ticket_comment.edit')}
                onClick={handleStartEditing}
              />
            </Tooltip>
          )}
        </div>

        {isEditing ? (
          <div className="ticket-comment__edit-form">
            <Form form={form} initialValues={{ content }}>
              <Form.Item
                name="content"
                rules={[{ required: true, message: I18n.t('errors.messages.blank') }]}
                className="tickets-index-page__form-item"
              >
                <TextArea rows={3} autoFocus />
              </Form.Item>
            </Form>
            <Space className="ticket-comment__edit-actions">
              <Button
                type="primary"
                size="small"
                icon={<CheckOutlined />}
                loading={isSaving}
                onClick={handleSave}
              >
                {I18n.t('helpers.submit.ticket_comment.update')}
              </Button>
              <Button
                size="small"
                icon={<CloseOutlined />}
                disabled={isSaving}
                onClick={handleCancel}
              >
                {I18n.t('helpers.submit.ticket_comment.cancel')}
              </Button>
            </Space>
          </div>
        ) : (
          <Paragraph className="ticket-comment__content">{content}</Paragraph>
        )}
      </div>
    </div>
  );
};

CommentItem.propTypes = {
  id: number,
  authorName: string,
  avatarUrl: string,
  content: string,
  createdAt: string,
  canEdit: bool,
  onUpdate: func,
};

export default CommentItem;
